import React from 'react';
import partner from '@/assets/images/main/aboutUs/partner.jpg';
import styles from './index.module.scss';

const WebBusinessMain = () => {
  return (
    <section className={styles['lei-slideinfo']}>
      <div className={styles['lei-info2']}>
        <div className={styles['lei-slideinfo-info']}>
          <div className={styles['lei-slideinfo-title']}>
            <h2>部分合作伙伴</h2>
            <p></p>
          </div>
          <div className={styles['lei-slideinfo-info']}>
            <div className={styles['lei-slideinfo-content']}>
              <div className={styles['lei-content-info']}>
                <div className={styles['lei-content-infos']}>
                  <div>
                    <img className={styles.lazyload} src={partner} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default WebBusinessMain;
